module.exports = __webpack_public_path__ + "static/Averta-Semibold-3a7a00a25dd090cdd028a6865fb0ad2d.woff";